import { httpGet } from '@inner-source/cis-shared/transports';

const getActiveRepos = async ({ limit = 6 } = {}) => httpGet('/get-most-active-repos-api', { limit });

export default getActiveRepos;
